import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.find.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VMask from './VMask';
import debounce from '@/utils/debounce';
import Common from '@/common';
import Drip from 'drip';
import { SHOW_STATUS } from '../ticket-good/constant';
export default {
  name: 'widget__sessionlist',
  components: {
    'v-mask': VMask
  },
  data: function data() {
    return {
      SHOW_STATUS: SHOW_STATUS,
      selected: null,
      isShowTop: false,
      isShowBottom: true,
      showList: [],
      hasSeasonTicket: false,
      useNewPromotion: !Drip.UA.IS_DouyinShowMicroApp
    };
  },
  mounted: function mounted() {
    var _this = this;
    // scroll 防抖
    debounce(function () {
      this.$refs.box.addEventListener('scroll', this.scroll);
    }, 300);
    // 添加季票标识
    this.showList = this.sessions.map(function (item) {
      return Object.assign(item, {
        // 是否季票
        isSeasonTicket: Common.checkIsSeasonTicket(_this.projectCategoryId, item.showType)
      });
    });
    this.hasSeasonTicket = this.showList.some(function (x) {
      return x.isSeasonTicket;
    });
  },
  props: {
    sessions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    stockout: {
      type: Boolean,
      default: false
    },
    onClose: {
      type: Function,
      default: function _default() {}
      // required: true,
    },

    onSessionSelect: {
      type: Function,
      default: function _default() {}
      // required: true,
    },

    projectCategoryId: {
      type: Number,
      required: true
    }
  },
  methods: {
    onSessionItemClick: function onSessionItemClick(_ref) {
      var showId = _ref.showId,
        unusualStatus = _ref.unusualStatus,
        showStatus = _ref.showStatus,
        onSaleTime = _ref.onSaleTime;
      if (unusualStatus === 1) {
        this.$emit('showProjectDelayPopup');
      } else if (showStatus === 3) {
        this.$emit('hintToSellEvent', onSaleTime);
      } else {
        this.selected = showId;
        this.onSessionSelect(showId);
      }
    },
    // 监听滚动事件
    scroll: function scroll() {
      var _this$$refs$box = this.$refs.box,
        scrollTop = _this$$refs$box.scrollTop,
        clientHeight = _this$$refs$box.clientHeight,
        scrollHeight = _this$$refs$box.scrollHeight;
      if (scrollTop > 20) {
        this.isShowTop = true;
      } else {
        this.isShowTop = false;
      }
      if (scrollTop + clientHeight >= scrollHeight - 20) {
        this.isShowBottom = false;
      } else {
        this.isShowBottom = true;
      }
    },
    showTagObj: function showTagObj(show) {
      // 场次维度的优惠信息展示顺序，见https://wiki.maoyan.com/pages/viewpage.action?pageId=247635178

      var itemType1 = show.promotionTags && show.promotionTags.find(function (item) {
        return item.type === 1;
      });
      var itemType3 = show.promotionTags && show.promotionTags.find(function (item) {
        return item.type === 3;
      });
      if (show.unusualStatus === 2) {
        return {
          text: '演出取消',
          class: 'show-item__cancel'
        };
      } else if (show.unusualStatus === 1) {
        return {
          text: '演出延期',
          class: 'show-item__delay'
        };
      } else if (show.showStatus === SHOW_STATUS.SOLD_OUT) {
        return {
          text: '售罄',
          class: 'show-item__soldout'
        };
      } else if (show.showStatus === SHOW_STATUS.TO_SALE) {
        return {
          text: '即将开售',
          class: 'show-item__tosale'
        };
      } else if (show.showStatus === SHOW_STATUS.STOCK_OUT) {
        return {
          text: '缺货登记',
          class: 'show-item__soldout_register'
        };
      } else if (show.promotionTags && show.promotionTags.some(function (item) {
        return item.type === 1;
      })) {
        if (this.useNewPromotion) {
          return {
            text: itemType1.tag,
            class: 'show-item__redeem'
          };
        } else {
          return {
            text: '可兑',
            class: 'show-item__redeem'
          };
        }
      } else if (show.promotionTags && show.promotionTags.some(function (item) {
        return item.type === 2;
      })) {
        return {
          text: '低价',
          class: 'show-item__lowest_price'
        };
      } else if (show.promotionTags && show.promotionTags.some(function (item) {
        return item.type === 3;
      })) {
        if (this.useNewPromotion) {
          return {
            text: itemType3.tag,
            class: 'show-item__redeem'
          };
        } else {
          return {
            text: '惠',
            class: 'show-item__discount'
          };
        }
      } else {
        return '';
      }
    },
    // 获取活动标签
    getActivityUrl: function getActivityUrl(show) {
      var promotionTags = show.promotionTags;
      if (!promotionTags) return '';

      // 活动标签
      if (promotionTags.some(function (item) {
        return item.type === 6;
      })) {
        return {
          url: promotionTags.find(function (item) {
            return item.type === 6;
          }).tag,
          style: 'border-radius: 3px'
        };
      }
      // 早鸟活动
      if (promotionTags.some(function (item) {
        return item.type === 7;
      })) {
        return {
          url: 'https://p0.pipi.cn/rock/prod/common/image/1594dacead6439c4fa173ffb36427c29.png?imageMogr2/thumbnail/2500x2500%3E',
          style: 'border-radius: 0px'
        };
      }
    }
  }
};